<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="字段顺序/扩展字段名称搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row>
          <el-form-item label="字段名称">
            <el-input
              v-model.trim="form.extendFieldName"
              placeholder="请输入扩展字段名称"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="控件类型">
            <el-select
              v-model="form.controlType"
              placeholder="请选择控件类型"
              clearable
              style="width:100%"
              size="small"
            >
              <el-option label="文本框" value="input" />
              <el-option label="下拉框" value="select" />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="字段类型">
            <el-select
              v-model="form.fieldType"
              placeholder="请选择字段类型"
              clearable
              size="small"
              style="width:100%"
            >
              <el-option label="文本" value="text" />
              <el-option
                label="数值"
                value="number"
                :disabled="isDisabledMultiple"
              />
              <el-option
                label="日期"
                value="date"
                :disabled="isDisabledMultiple"
              />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="字段长度">
            <el-input-number
              v-model="form.fieldLength"
              placeholder="请输入字段长度"
              clearable
              size="small"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="是否必填">
              <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
                <el-checkbox-group v-model="form.isRequiredList">
                  <el-checkbox label="Y">是</el-checkbox>
                  <el-checkbox label="N">否</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="是否多选">
              <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
                <el-checkbox-group v-model="form.isMultipleList">
                  <el-checkbox label="Y" :disabled="isDisabledMultiple"
                    >是</el-checkbox
                  >
                  <el-checkbox label="N">否</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="是否使用">
            <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
              <el-checkbox-group v-model="form.isEnableList">
                <el-checkbox label="Y">是</el-checkbox>
                <el-checkbox label="N">否</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  isEnableList: ['Y'],
  isMultipleList: [],
  isRequiredList: [],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      isDisabledMultiple: false,
      isDisabledFieldType: false,
    }
  },
  created() {
    this.query()
  },
  watch: {
    /**
     * 侦听界面控件类型属性，修改字段类型并禁用元素，修改是否多选并禁用元素
     */
    'form.controlType'() {
      if (this.form.controlType === 'input') {
        this.isDisabledMultiple = false
        this.isDisabledFieldType = false
      } else {
        if (this.form.fieldType != 'text') {
          this.form.fieldType = ''
        }
        if (this.form.isMultipleList[0] === 'Y') {
          this.form.isMultipleList.splice('Y',1)
        }
        this.isDisabledMultiple = true
        this.isDisabledFieldType = true
      }
    },
    /**
     * 侦听字段类型属性，清零字段长度，并禁用组件
     */
    'form.fieldType'() {
      if (this.form.fieldType === 'date') {
        this.form.fieldLength = 0
        this.isDisabledFieldLength = true
      } else {
        this.isDisabledFieldLength = false
      }
    },
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
